<template>
    <slot name="header" />

    <flex-container no-wrap>
        <input-group
            v-model="form.type"
            :schema="object().required()"
        >
            <template #input>
                <select-input
                    :items="FilterType.values"
                >
                    <template #active="{ bindings }">
                        <span>URL {{ bindings.value.label.toString().toLowerCase() }}</span>
                    </template>
                    <template #item="{ bindings }">
                        <span>URL {{ bindings.item.label.toString().toLowerCase() }}</span>
                    </template>
                </select-input>
            </template>
        </input-group>

        <input-group
            v-model="form.value"
        >
            <template #input>
                <text-input />
            </template>
        </input-group>
        <flex-container size="auto">
            <button-outline @click="addFilter">
                Toevoegen
            </button-outline>
        </flex-container>
    </flex-container>
    <flex-container class="list-container">
        <list-container>
            <template #content>
                <list-row
                    v-for="(filter, index) in localFilters"
                    :key="filter.value"
                >
                    <list-cell-text>
                        <template #content>
                            <text-decorator :size="FontSize.sm">
                                {{ filter.type.label }}
                            </text-decorator>
                        </template>
                    </list-cell-text>
                    <list-cell-text>
                        <template #content>
                            <text-decorator :size="FontSize.sm">
                                {{ filter.value }}
                            </text-decorator>
                        </template>
                    </list-cell-text>
                    <flex-container justify-content="flex-end">
                        <list-cell-icon
                            :icon="DeleteIcon"
                            :color="'red-500'"
                            :size="IconSize.md"
                            @click="deleteFilter(index)"
                        />
                    </flex-container>
                </list-row>
            </template>
        </list-container>
    </flex-container>
</template>

<script setup lang="ts">
    import { object } from 'yup';
    import {
        ButtonOutline,
        FlexContainer,
        FontSize,
        IconSize,
        InputGroup,
        ListCellIcon,
        ListCellText,
        ListContainer,
        ListRow,
        SelectInput,
        TextDecorator,
        TextInput,
    } from '@keyvue/one-ui';
    import DeleteIcon from '@keyvue/one-material-icons/icons/delete.svg?component';
    import { Filter, FilterType } from '@keyvue/one-api-client';
    import { ref } from 'vue';

    interface Props {
        filters: Filter[]
    }

    const props = defineProps<Props>();

    const emit = defineEmits<{
        (e: 'filter:add', value: Filter): void;
        (e: 'filter:delete', value: number): void;
    }>();

    const localFilters = props.filters;

    interface Form {
        type: FilterType,
        value: string,
    }

    const form = ref<Form>({
        type: FilterType.values[0],
        value: '',
    });

    function addFilter() {
        if (form.value.value.trim() === '') {
            return;
        }

        emit('filter:add', { ...form.value } as Filter);
        form.value.value = '';
    }

    function deleteFilter(index: number) {
        emit('filter:delete', index);
    }
</script>

<style scoped lang="scss">
.list-container {
    box-sizing: border-box;
    height: 30vh;
    overflow-y: scroll;
    position: relative;
}
</style>
